import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4f6d4fe9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uni" }
const _hoisted_2 = { class: "uni__elm" }
const _hoisted_3 = { class: "uni__elm-widget" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = {
  key: 0,
  class: "uni__elm-widget-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          ref: "input",
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onEvent && _ctx.onEvent(...args))),
          type: "number",
          class: "uni__elm-widget-input",
          placeholder: _ctx.label
        }, null, 40, _hoisted_4)
      ]),
      (_ctx.isError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " * " + _toDisplayString(_ctx.messageError), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}